<template>
  <div class="home">asdf</div>
</template>

<script>
export default {}
</script>
